import { render } from "./PageHeader.vue?vue&type=template&id=0ff2f784"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
script.render = render

export default script